// src/config/axiosConfig.js
/* global gdAlertify */
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate si usas React Router

// const baseURL = 'http://localhost/sk-medical-back';  // URL base de tu API
const baseURL = 'https://intra.skmc.cl/sk-medical-back';  // URL base de tu API

const axiosInstance = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

export const setAuthToken = (token) => {
    if (token) {
        axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
    } else {
        delete axiosInstance.defaults.headers['Authorization'];
    }
};

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error(error);
        if (error.response && error.response.status === 401) {
            localStorage.clear();
            gdAlertify.notiError("Su sesión ha expirado, por favor inicie sesión nuevamente.");
            window.location.href = '/';
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
